export const extractURLWithHash = (window: Window, newHash: string): string => {
	const fullURLWithHash = window.location.href;
	const existingHashIfAny = window.location.hash;
	const urlWithHash = fullURLWithHash.replace(existingHashIfAny, '') + newHash;
	return urlWithHash;
};
